import { Component, OnInit, ElementRef, ViewChild, Inject, ViewChildren, QueryList, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { CartService } from '../../providers/cart.service';
import { ConstantService } from '../../providers/constants';
import { CoursesService } from '../../providers/courses.service';
import { DashboardService } from '../../providers/dashboard.service';
import { LoginService } from '../../providers/login.service';
import { CallActionDialog, LoginModal } from '../header/header.component';
import { DOCUMENT } from '@angular/common';
import { VideoPlayerDialog } from '../home/home.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {  MatBottomSheet } from '@angular/material/bottom-sheet';
import { StarMentorsDialog ,GalleryDialog} from '../home-latest/home-latest.component';
import { DeviceDetectorService } from 'ngx-device-detector';

declare var $:any;

@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss']
})


export class NewProductComponent implements OnInit {

  topperIndex:number = 0;

  aboveTemplate1:any = ` <div class="container">
  <div class="row justify-content-center">
  <div class="col-md-12">
  <div class="img-div">
  <img src="https://media.iquanta.in/ui_images/new-home/doubt-5.jpeg">
  </div>
  </div>
  </div>
  </div>`

  colorsList: any[] = [
    { 'theme1': '#5a007b', 'theme2': '#34006e' },
    { 'theme1': '#f94a75', 'theme2': '#f22183' },
    { 'theme1': '#00b3fe', 'theme2': '#0079fe' },
    { 'theme1': '#e443a3', 'theme2': '#b222c0' },
    { 'theme1': '#5200ce', 'theme2': '#4501a6' },
    { 'theme1': '#fd686a', 'theme2': '#f63f78' },
    { 'theme1': '#5a007b', 'theme2': '#34006e' },
    { 'theme1': '#f94a75', 'theme2': '#f22183' },
    { 'theme1': '#00b3fe', 'theme2': '#0079fe' },
    { 'theme1': '#e443a3', 'theme2': '#b222c0' },
    { 'theme1': '#5200ce', 'theme2': '#4501a6' },
    { 'theme1': '#fd686a', 'theme2': '#f63f78' },
  ]

  slideConfig4 = {
    "slidesToShow": 3, "slidesToScroll": 3,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  
  
  
  };

  lowtohigh:any[]=[
    'https://media.iquanta.in/ui_images/new-home/low-high-01.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-02.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-03.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-hight-04.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-05.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-06.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-07.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-08.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-09.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-10.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-11.jpeg',
    'https://media.iquanta.in/ui_images/new-home/low-high-12.jpeg',

  ]

  colorsList1: any[] = [
    { 'theme1': '#1fd3e7', 'theme2': '#44b0f6' },
    { 'theme1': '#666fe3', 'theme2': '#48519d' },
    { 'theme1': '#fc696e', 'theme2': '#fd8f4e' },
    { 'theme1': '#1fd3e7', 'theme2': '#44b0f6' },
    { 'theme1': '#666fe3', 'theme2': '#48519d' },
    { 'theme1': '#fc696e', 'theme2': '#fd8f4e' }
  ]
  public displayShareButtons: boolean = false;

  productId: any;

  productDetails: any;

  videoUrl: any;

  featuresList: any[] = [];

  phasesList: any[] = [];

  faqsList: any[] = [];

  descCount: any = 426;
  descCount1:any = 426;

  allFeedback: any[] = []
  doubtSolving: any[] = []
  heighScore: any[] = []
  peerToPeer: any[] = []
  contentRelavency: any[] = []
  dualPedagogy: any[] = []

  slideConfig = {
    "slidesToShow": 1, "slidesToScroll": 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    // responsive: [
    //   {
    //     breakpoint: 1024,
    //     settings: {
    //       slidesToShow: 3
    //     }
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 2
    //     }
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1
    //     }
    //   }
    // ]
  };

  slideConfig2 = {
    "slidesToShow": 1, "slidesToScroll": 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  slideConfig1 = {
    "slidesToShow": 1, 
    "slidesToScroll": 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',

  };

  date: any;
  now: any;
  targetDate: any = new Date();
  targetTime: any = this.targetDate.getTime();
  difference: number = 0;
  months: Array<string> = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  currentTime: any = `${this.months[this.targetDate.getMonth()]
    } ${this.targetDate.getDate()}, ${this.targetDate.getFullYear()}`;

  // @ViewChild('days', { static: true }) days!: ElementRef;
  // @ViewChild('hours', { static: true }) hours!: ElementRef;
  // @ViewChild('minutes', { static: true }) minutes!: ElementRef;
  // @ViewChild('seconds', { static: true }) seconds!: ElementRef;
  @ViewChild("myTooltip") myTooltip!: MatTooltip;
  intervalForDays: any;

  constructor(public ac: ActivatedRoute, public coursesService: CoursesService,
    public sanitizer: DomSanitizer,
    public dialog: MatDialog,
    public constantService: ConstantService,
    public dashboardService: DashboardService,
    @Inject(DOCUMENT) public dom: any,
    @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public loginService: LoginService,
    public matSnackBar: MatSnackBar,
    public cartService: CartService,
    public router: Router,
    private titleService: Title, private metaService: Meta,
    private _bottomSheet: MatBottomSheet,
    public elementRef: ElementRef,
    public deviceService : DeviceDetectorService,
    public constantsService: ConstantService
  ) { }
  viewCount: any = 6;
  viewCount1: any = 6;
  viewCount2: any = 6;
  viewCount3: any = 6;
  viewCount4: any = 6;
  viewCount5: any = 6;
  token: any;
  discountAmount: number = 0;
  couponCode: any;
  productName: any;

  public scrolling = false;
  private timeout: any;

  @HostListener('window:scroll', ['$event'])
  onScroll1(event: any) {
    this.scrolling = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.scrolling = false;
    }, 200);
  }

  gotodashboard(){
    this.sessionStorage.setItem('selId', this.productDetails.linked_courses[0].id);
    this.router.navigate(['/dashboard/my-courses/overview'])
  }

  changeCourse(ev: any) {
    this.productName = ev.replace(/-/g, ' ');
    this.getProductDetails()
    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.getProfile()
      this.getProfileData()
      this.getWishList()
    }
  }

  
joinwhatsappEnquiry(link:any){
let whatsappTemplate:any = `Hi iQuanta! 

I’m interested in the ${this.productDetails.name} and have a few questions about the syllabus, fees, batch dates and remaining seats. Could you please help me with the details? 

Thanks!`
window.open(link+'&text='+encodeURI(whatsappTemplate), '_blank')

}

  joinwhatsapp(link: any) {
    window.open(link, '_blank')
  }

  openBlog(val: any) {
    window.open(val, '_blank')
  }
  demovideos1() {
    window.open('https://www.youtube.com/@iquanta-UPSC5564', '_blank')
  }
  openPlaylist(val: any) {
    window.open(val, '_blank')
  }

  demovideos() {
    window.open('https://www.youtube.com/watch?v=-1jgvAD_2CQ&list=PLxyv2AaZ_Odsw_QsNPn7n7Q70rrN_C-Cn', '_blank')
  }

  topperIndexPrevChange(){
    if(this.topperIndex > 0){
      this.topperIndex--
    }
  }

  topperIndexNextChange(){
    if(this.topperIndex < 6){
      this.topperIndex++
    }
  }

  topperListFeedback: any[] = [
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-1.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-02.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-03.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-04.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-05.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-06.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-07.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-08.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-09.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-10.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-11.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-12.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-13.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-14.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-15.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-16.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-17.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-18.webp',
  ]

  joinwhatsapp1() {
    window.open('https://chat.whatsapp.com/J9g4j8G0KL20Qoff2fO0c2', '_blank')
  }

  activeFooterTab: any = 'course-details';
  playVideoFlagStory:boolean = false;
  videoLink: any
  videoPlay(obj: any) {
    this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + obj.video + '?rel=0')
    $('#VideoPlayer').modal()
    //  let modal:any = document.getElementById('VideoPlayer')
    //  modal.show()
  }

  goToSection(val: any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
    this.activeFooterTab = val;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if(this.deviceService.isDesktop()){
      let div1: any = document.getElementById('course-details');
      const viewportOffset1 = div1.getBoundingClientRect();
      const top1 = viewportOffset1.top;
      if (top1 < 100) {
        this.activeFooterTab = 'course-details';
      }
  
      let div2: any = document.getElementById('course-features');
      const viewportOffset2 = div2.getBoundingClientRect();
      const top2 = viewportOffset2.top;
      if (top2 < 100) {
        this.activeFooterTab = 'course-features';
      }
  
      let div6: any = document.getElementById('course-content');
      const viewportOffset6 = div6.getBoundingClientRect();
      const top6 = viewportOffset6.top;
      if (top6 < 100) {
        this.activeFooterTab = 'course-content';
      }
  
      let div3: any = document.getElementById('faculties');
      const viewportOffset3 = div3.getBoundingClientRect();
      const top3 = viewportOffset3.top;
      if (top3 < 100) {
        this.activeFooterTab = 'faculties';
      }
  
      let div4: any = document.getElementById('features');
      const viewportOffset4 = div4.getBoundingClientRect();
      const top4 = viewportOffset4.top;
      if (top4 < 100) {
        this.activeFooterTab = 'features';
      }
  
      let div5: any = document.getElementById('toppers-feedback');
      const viewportOffset5 = div5.getBoundingClientRect();
      const top5 = viewportOffset5.top;
      if (top5 < 100) {
        this.activeFooterTab = 'toppers-feedback';
      }
  
      let div7: any = document.getElementById('featured-courses');
      const viewportOffset7 = div7.getBoundingClientRect();
      const top7 = viewportOffset7.top;
      if (top7 < 100) {
        this.activeFooterTab = 'featured-courses';
      }
    }
  
  }

  productBannerDetails: any;

  getBanner() {
    this.coursesService.getProductBanner(this.productId).subscribe(res => {
      if (res.success) {
        if (res.data[0]) {
          if(res.data[0].status){
            this.productBannerDetails = res.data[0];
          }
        }
      }
    })
  }

  bannerImageData: any[] = []
  getBannerImages() {
    this.coursesService.getBannerImages(this.productId).subscribe(res => {
      if (res.success) {
        this.bannerImageData = res.data;
      }
    })
  }
tableData:any;

  ngOnInit() {
    this.tableData = this.constantsService.courseComparison1;

    this.productName = this.ac.snapshot.params['id'].replace(/-/g, ' ');
    this.doubtSolving = this.constantService.doubtSolving;
    this.contentRelavency = this.constantService.contentRelavency;
    this.heighScore = this.constantService.heighScore;
    this.peerToPeer = this.constantService.peerToPeer;
    this.dualPedagogy = this.constantService.dualPedagogy;
    this.allFeedback = this.doubtSolving.concat(this.heighScore.concat(this.peerToPeer.concat(this.contentRelavency.concat(this.dualPedagogy))))
   
    if(this.productName == 'tiss course 2023'){
    this.router.navigate(['/details/cuet-pg-course-2025'])
    // location.reload()
   }else if(this.productName == 'cat 2024 full course'){
    this.router.navigate(['/cat-2025'])
    // location.reload()

   }
   else if(this.productName == 'nmat snap course 2023' || this.productName == 'nmat snap course 2024'){
    this.router.navigate(['/snap-online-coaching'])
    // location.reload()
   }
   else if(this.productName == 'micat course 2023'){
    this.router.navigate(['/details/micat-course-2025'])
    // location.reload()
   }
 
    this.getProductDetails()
    if(this.dom.URL.includes('?coupon_code=')){
      this.couponCode = this.dom.URL.split('?coupon_code=')[1]
    
    }

    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.getProfile()

      this.getWishList()
    }
    this.getProfileData()
    // this.getFakeNumber()
  }
  showTooltipFlag1: boolean = false;
  displayTooltip() {
    this.showTooltipFlag1 = true;
    // this.myTooltip.disabled = false;
    // this.myTooltip.show()
    // setTimeout(() => {
    //   this.myTooltip.disabled = true;
    // }, 1000);
  }
  profileData: any;
  getProfileData() {
    this.loginService.profileData.subscribe(res => {
      if (res) {
        this.token = this.sessionStorage.getItem('usertoken');
        this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
      }
    })
  }

  courseDetails(courseObj: any) {
    window.open(courseObj.course_link, '_self')
  }

  referralAmount: number = 0;
  referralCode: any;
  //coupon Modal
  couponOpen() {
    if (this.token) {
      const dialog = this.dialog.open(ProductCouponDialog1, {
        width: '470px',
        panelClass: 'coupon-modal',
        data: this.productId
      })
      dialog.afterClosed().subscribe(res => {
        if (res) {
          if (res.data == 'Invalid Code or Not available for this course') {
            this.sessionStorage.removeItem('couponCode')
          } else if (res.data == 'referral_code does not exist') {
            this.sessionStorage.removeItem('referralCode')
          } else {
            if (res.data[0].amount) {
              this.referralAmount = res.data[0].amount;
              this.referralCode = this.sessionStorage.getItem('referralCode')
              this.getTotalPrice()

            } else {
              this.discountAmount = res.data[0].discount_amount;
              this.couponCode = this.sessionStorage.getItem('couponCode');
              this.getTotalPrice()
            }
            this.timerconfig = {
              leftTime: 900,
              notify: [5]
            }
          }
        }
      })
    } else {
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {

        } else if (typeof (result) == 'object') {
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()
          } else {
            this.gmaillogin(result, 'coupon')
          }
        }
      });
    }

  }

  applycoupon(){
    this.discountAmount = this.personalisedCoupon.discount_amount;
    this.couponCode = this.personalisedCoupon.coupon_code;
    this.timerconfig = {
      leftTime: 900,
      notify: [5]
    }
    this.getTotalPrice()
  }

  getProfile() {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.userData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.loginService.userProfile(this.userData)
        if(this.dom.URL.includes('?referral_code=')){
          this.referralCode = this.dom.URL.split('?referral_code=')[1];
          this.applyReferralCode()
        }
      }
    })
  }
  userData: any;
  gmaillogin(reqObj: any, type: any) {
    let reqData = {
      id: reqObj.google_id,
      username: reqObj.name + '-' + reqObj.google_id,
      email: reqObj.email,
      gmail_pic: reqObj.google_pic
    }
    this.loginService.gmail_login(reqData).subscribe(res => {
      if (res.success) {
        this.userData = reqData;
        this.token = res.key;
        this.sessionStorage.setItem('usertoken', this.token);
        this.sessionStorage.setItem('userData', JSON.stringify(reqData));
        this.loginService.userProfile(this.userData)
        // this.onLogin.emit(this.token)
        if (type == 'checkout') {
          this.loginService.userProfile(this.userData)
        } else {
          this.couponOpen()
        }
      }
    })
  }

  submittedBuynow: boolean = false;

  buynow(obj: any) {
    let hardcopyList: any[] = [];
    this.addonList.forEach(addon => {
      hardcopyList.push(addon.contains_hardcopy)
    })
    if (!this.submittedBuynow) {
      if (this.token) {
        if (this.userData.email && this.userData.phone_no && this.userData.first_name) {
          if (this.productDetails.contains_hardcopy || hardcopyList.includes(true)) {
            const dialog = this.dialog.open(FormDialog, {
              width: '450px',
              panelClass: 'enquiry-modal',
              data: this.userData
            })
            dialog.afterClosed().subscribe(res => {
              if (res) {
                this.submittedBuynow = true;
                let courseList: any[] = [];
                this.addonList.forEach(addon => {
                  courseList.push(addon.id)
                })
                let reqObj: any;
                if (this.couponCode) {
                  reqObj = {
                    email: obj ? obj.email : this.userData.email,
                    phone: obj ? obj.phone : this.userData.phone_no,
                    product_id: this.productId,
                    course_list: courseList,
                    coupon_code: this.couponCode,
                    subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
                  }
                } else if (this.referralCode) {
                  reqObj = {
                    email: obj ? obj.email : this.userData.email,
                    phone: obj ? obj.phone : this.userData.phone_no,
                    product_id: this.productId,
                    course_list: courseList,
                    referral_code: this.referralCode,
                    subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
                  }
                } else {
                  reqObj = {
                    email: obj ? obj.email : this.userData.email,
                    phone: obj ? obj.phone : this.userData.phone_no,
                    product_id: this.productId,
                    course_list: courseList,
                    subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
                  }
                }
                this.cartService.productCheckout(this.token, reqObj).subscribe(res => {
                  if (res.success) {
                    this.sessionStorage.setItem('order_id', res.order_id)
                    this.productDetails.addOns = courseList;
                    if (this.discountAmount > 0) {
                      this.productDetails.discount_amount = this.discountAmount;
                    } else if (this.referralAmount > 0) {
                      this.productDetails.referral_amount = this.referralAmount;
                    }
                    this.sessionStorage.setItem('productArray', JSON.stringify(this.productDetails))
                    if (res.redirect_url) {
                      let url = res.redirect_url.split('?')
    
                      this.sessionStorage.setItem('queryParams', JSON.stringify(url[url.length - 1]))
                      this.router.navigate(['/success'])
                    } else {
                      // alert(JSON.stringify(res))
                      window.open(res.data, '_self')
                    }
                  } else {
                    this.submittedBuynow = false;
                    this.matSnackBar.open(res.data, 'OK', {
                      verticalPosition: 'top',
                      duration: 3000,
                      panelClass: 'snack-error'
                    })
                  }
                })
              }
            })
          } else {
            this.submittedBuynow = true;
            let courseList: any[] = [];
            this.addonList.forEach(addon => {
              courseList.push(addon.id)
            })
            let reqObj: any;
            if (this.couponCode) {
              reqObj = {
                email: obj ? obj.email : this.userData.email,
                phone: obj ? obj.phone : this.userData.phone_no,
                product_id: this.productId,
                course_list: courseList,
                coupon_code: this.couponCode,
                subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
              }
            } else if (this.referralCode) {
              reqObj = {
                email: obj ? obj.email : this.userData.email,
                phone: obj ? obj.phone : this.userData.phone_no,
                product_id: this.productId,
                course_list: courseList,
                referral_code: this.referralCode,
                subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
              }
            } else {
              reqObj = {
                email: obj ? obj.email : this.userData.email,
                phone: obj ? obj.phone : this.userData.phone_no,
                product_id: this.productId,
                course_list: courseList,
                subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
              }
            }
            this.cartService.productCheckout(this.token, reqObj).subscribe(res => {
              if (res.success) {
                this.sessionStorage.setItem('order_id', res.order_id)
                this.productDetails.addOns = courseList;
                if (this.discountAmount > 0) {
                  this.productDetails.discount_amount = this.discountAmount;
                } else if (this.referralAmount > 0) {
                  this.productDetails.referral_amount = this.referralAmount;
                }
                this.sessionStorage.setItem('productArray', JSON.stringify(this.productDetails))
                if (res.redirect_url) {
                  let url = res.redirect_url.split('?')

                  this.sessionStorage.setItem('queryParams', JSON.stringify(url[url.length - 1]))
                  this.router.navigate(['/success'])
                } else {
                  // alert(JSON.stringify(res))
                  window.open(res.data, '_self')
                }
              } else {
                this.submittedBuynow = false;
                this.matSnackBar.open(res.data, 'OK', {
                  verticalPosition: 'top',
                  duration: 3000,
                  panelClass: 'snack-error'
                })
              }
            })
          }

        } else {
          this.matSnackBar.open('Please update your Profile to continue', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        }

      } else {
        const dialogRef = this.dialog.open(LoginModal, {
          width: '750px',
          panelClass: 'login_modal',
          autoFocus: false,
          data: ''
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result == 'yes') {

          } else if (typeof (result) == 'object') {
            if (this.sessionStorage.getItem('usertoken')) {
              this.token = this.sessionStorage.getItem('usertoken');
              this.getProfile()
            } else {
              this.userData = result;
              this.token = this.sessionStorage.getItem('usertoken');;
              this.sessionStorage.setItem('userData', JSON.stringify(result));
              this.loginService.userProfile(this.userData)
            }
          }
        });
      }
    }
  }

  courseLink(obj:any){
    // window.open(obj.course_link, '_blank')
    this.router.navigate([obj.course_link])
  }


  totalAmount: number = 0;
  getTotalPrice() {
    let total = 0;
    if (this.addonList.length == 0) {
      total = this.productDetails.price - (this.discountAmount ? this.discountAmount : this.referralAmount);
    } else {
      let subtotal = 0;
      this.addonList.forEach(course => {
        subtotal = subtotal + course.offer_price
      })
      total = (this.productDetails.price - (this.discountAmount ? this.discountAmount : this.referralAmount)) + subtotal;
    }

    this.totalAmount = total;
  }

  wishList: any[] = []
  addToWishlist() {
    if (this.token) {
      this.coursesService.addToWishList({ product_id: this.productId }, this.token).subscribe(res => {
        if (res.success) {
          this.addInternalCRMLead()
          this.matSnackBar.open('Added to Wishlist', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-success'
          })
          this.wishList.push(this.productId)
        }
      })
    } else {
      this.matSnackBar.open('Please Login to Wishlist', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }
  }

  addInternalCRMLead() {
    // if (this.token) {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "orgId": "66dec57ce200bc89284602d6",
      "uid": '66dec57ce200bc89284602d6',
      "userId": this.userData ? this.userData.id : 9999,
      "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
      "name": this.userData.first_name + ' ' + this.userData.last_name,
      "firstName": this.userData.first_name + ' ' + this.userData.last_name,
      "countryCode": 91,
      "phone": this.userData.phone_no,
      "email": this.userData.email,
      "source": "Website",
      "medium": "Wishlist",
      "campaign": this.productDetails.name,
      "pageLocation": this.dom.URL,
      "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
      "registrationDevice": this.deviceService.deviceType,
      "ipAddress": this.sessionStorage.getItem('ipAddress'),
      "customFields": {
        "exam": this.userData.exam.join(','),
        "examCategory": this.userData.exam_category,
        "examTargetYear": 2025,
      "leadPriority": "Platinum",

      },
      dataSource: [
        {
          utmSource: source,
          utmMedium: medium,
          utmCampaign: campaign,
          utmAdContent: "",
          "pageLocation": this.dom.URL,
          "source": "Website",
          "medium": "Wishlist",
          "campaign": this.productDetails.name,
          adContent: "",
  
          browser: this.deviceService.browser,
          browser_version: this.deviceService.browser_version,
          device: this.deviceService.device,
          deviceType: this.deviceService.deviceType,
          orientation: this.deviceService.orientation,
          os: this.deviceService.os,
          os_version: this.deviceService.os_version,
          platformId: this.deviceService['platformId'],
          ua: this.deviceService.ua,
          userAgent: this.deviceService.userAgent,
          "ipAddress": this.sessionStorage.getItem('ipAddress'),
        },
      ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {

        }
      })
    // }
  }

  getWishList() {
    this.wishList = [];
    this.dashboardService.getWishList(this.token).subscribe(res => {
      if (res.success) {
        res.data.forEach((item: any) => {
          item.product.forEach((item1: any) => {
            this.wishList.push(JSON.stringify(item1.id))
          })
        })
      }
    })
  }

  removeWishlist() {
    this.dashboardService.removeWishlist(this.token, this.productId).subscribe(res => {
      if (res.success) {
        this.matSnackBar.open('Removed from Wishlist', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-success'
        })
        this.getWishList()
      }
    })
  }

  addonList: any[] = []
  addonCourse(ev: any, obj: any) {
    if (!ev.checked) {
      let i = this.addonList.indexOf(obj)
      this.addonList.splice(i, 1)
    } else {
      this.addonList.push(obj)
    }
    this.getTotalPrice()
  }

  viewMore(val: any) {
    if (val == '1') {
      if (this.viewCount < this.allFeedback.length) {
        this.viewCount = this.viewCount + 6;
      }
    } else if (val == '2') {
      if (this.viewCount1 < this.doubtSolving.length) {
        this.viewCount1 = this.viewCount1 + 6;
      }
    } else if (val == '3') {
      if (this.viewCount2 < this.dualPedagogy.length) {
        this.viewCount2 = this.viewCount2 + 6;
      }
    } else if (val == '4') {
      if (this.viewCount3 < this.contentRelavency.length) {
        this.viewCount3 = this.viewCount3 + 6;
      }
    } else if (val == '5') {
      if (this.viewCount4 < this.heighScore.length) {
        this.viewCount4 = this.viewCount4 + 6;
      }
    } else if (val == '6') {
      if (this.viewCount5 < this.peerToPeer.length) {
        this.viewCount5 = this.viewCount5 + 6;
      }
    }

  }

  viewLess(val: any) {
    if (val == '1') {
      this.viewCount = 6;
    } else if (val == '2') {
      this.viewCount1 = 6;
    } else if (val == '3') {
      this.viewCount2 = 6;
    } else if (val == '4') {
      this.viewCount3 = 6;
    } else if (val == '5') {
      this.viewCount4 = 6;
    } else if (val == '6') {
      this.viewCount5 = 6;
    }
  }

  removeCoupon() {
    this.discountAmount = 0;
    this.couponCode = '';
    this.sessionStorage.removeItem('couponCode')
    this.sessionStorage.removeItem('referralCode')
    this.referralAmount = 0;
    this.referralCode = '';
    this.getTotalPrice()
  }


  tickTock() {
    this.date = new Date();
    this.now = this.date.getTime();
    // this.days.nativeElement.innerText = Math.floor(this.difference);
    // this.hours.nativeElement.innerText = 23 - this.date.getHours();
    // this.minutes.nativeElement.innerText = 60 - this.date.getMinutes();
    // this.seconds.nativeElement.innerText = 60 - this.date.getSeconds();
  }

  gotolink() {
    if (this.toolTipObj.course_link) {
      window.open(this.toolTipObj.course_link)
    }
  }

  gotolink1() {
    if (this.productDetails.addons[0].course_link) {
      this.showTooltipFlag1 = false;
      window.open(this.productDetails.addons[0].course_link)
    }
  }

  hideToolTip() {
    this.showTooltipFlag = false;
    this.toolTipObj = '';
  }

  toolTipObj: any

  showTooltip(addon: any) {
    this.showTooltipFlag = true;
    this.toolTipObj = addon;
  }
  showTooltipFlag: boolean = false;

  openBannerLink() {
    window.open(this.productBannerDetails.link, '_blank')
  }

  timerconfig:any = {

  }
  timerEvent: any;

  handleEvent(ev: any) {
    if (ev.action == 'done') {
      this.timerEvent = ev;
    }
    //  else if (ev.action == 'notify') {
    //   this.timerEvent = ev;
    // }
  }
  json1:any;
  json2:any;
  json3:any;
  json4:any;
  getProductDetails() {
    this.coursesService.getProductDetails(this.productName).subscribe((res: any) => {
      if (res.success) {
        if(res.data.length > 0){
          this.productDetails = res.data[0];
          let schemaList:any[]=[];
          if(this.productDetails.schema){
            schemaList = JSON.parse(this.productDetails.schema);
          }
          if(schemaList){
            if(schemaList[0]){
              this.json1 = JSON.parse(schemaList[0])
            }
            if(schemaList[1]){
              this.json2 = JSON.parse(schemaList[1])
            }
            if(schemaList[2]){
              this.json3 = JSON.parse(schemaList[2])
            }
            if(schemaList[3]){
              this.json4 = JSON.parse(schemaList[3])
            }
          }
       
            if(this.productDetails.faculty_image_list == null){
              this.productDetails.faculty_image_list = []
            }
          if(!this.productDetails){
            this.router.navigate(['/404'])
          }
          this.productId = this.productDetails.id;
          this.activePhase = this.productDetails.phases[0]
          this.getTotalPrice()
          this.getFakeNumber()
          this.getFaqs()
          this.getBanner()
          this.getBannerImages()
          this.getCoupons()
          this.productDetails.addons.forEach((addon:any)=>{
            addon.special_price = addon.offer_price - ((10/100) * addon.offer_price)
            // addon.special_price = addon.offer_price
          })

          if(this.sessionStorage.getItem('enrollNow')){
            if(this.deviceService.isDesktop()){
              this.addOnCoupon()
            }else{
              this.buynow1()
            }
          }
          // Meta Data
          this.titleService.setTitle(this.productDetails.meta_title);
          this.metaService.updateTag(
            { name: 'description', content: this.productDetails.meta_description });
          // this.metaService.updateTag( 
          //   { name: 'keywords', content: 'cmat course,cmat full course,cmat full course 2023,cmat course 2023,cmat course 2024,cmat online coaching,cmat online classes' });
          // Canonical Link
          const head = this.dom.getElementsByTagName('head')[0];
          var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
          head.appendChild(element);
          element.setAttribute('rel', 'canonical')
          element.setAttribute('href', 'https://www.iquanta.in/details/' + this.productName.toLowerCase().replace(/ /g, '-'))
          // Facebook
          this.metaService.updateTag(
            { property: 'og:type', content: "website" })
          this.metaService.updateTag(
            { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
          this.metaService.updateTag(
            { property: 'og:title', content: (this.productDetails.meta_title) })
          this.metaService.updateTag(
            { property: 'og:url', content: 'https://www.iquanta.in/details/' + this.productName.toLowerCase().replace(/ /g, '-') })
          this.metaService.updateTag(
            { property: 'og:description', content: this.productDetails.meta_description });
          this.metaService.updateTag(
            { name: 'keywords', content: this.productDetails.meta_keyword });
          this.metaService.updateTag(
            { property: 'og:image:height', content: '720' })
          this.metaService.updateTag(
            { property: 'og:image:width', content: '1280' })
          this.metaService.updateTag(
            { property: 'og:image:type', content: 'image/jpeg' })
          this.metaService.updateTag(
            { property: 'og:image', content: this.productDetails.meta_image_url })
            let created:any; 
            if(this.productDetails.created_on.includes('.')){
              created = this.productDetails.created_on.split('.')[0]
            }else{
              created = this.productDetails.created_on
            }
          // Article Publish Time
          this.metaService.updateTag(
            { property: 'article:published_time', content: created + '+00:00' })
          this.metaService.updateTag(
            { property: 'article:modified_time', content: '2024-09-06T11:10:42+00:00' })
            if(this.productDetails.modified_on){
              this.metaService.updateTag(
                { property: 'article:modified_time', content: this.productDetails.modified_on.replace('Z', '+00:00') })
            }
          // Twitter
          this.metaService.updateTag(
            { property: 'twitter:label2', content: "Est. reading time" })
          this.metaService.updateTag(
            { property: 'twitter:data2', content: "7 Minutes" })
          this.metaService.updateTag(
            { property: 'twitter:title', content: (this.productDetails.meta_title) })
          this.metaService.updateTag(
            { property: 'twitter:url', content: 'https://www.iquanta.in/details/' + this.productName.toLowerCase().replace(/ /g, '-') })
          this.metaService.updateTag(
            { property: 'twitter:description', content: this.productDetails.meta_description });
          this.metaService.updateTag(
            { property: 'twitter:image', content: this.productDetails.meta_image_url })
          this.metaService.updateTag(
            { property: 'twitter:image:height', content: '720' })
          this.metaService.updateTag(
            { property: 'twitter:image:type', content: 'image/jpeg' })
          this.metaService.updateTag(
            { property: 'twitter:image:width', content: '1280' })
          if (this.productDetails.index) {
            this.metaService.addTag(
              { name: 'robots', content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" })
          } else {
            this.metaService.addTag(
              { name: 'robots', content: "noindex" })
          }
          this.featuresList = this.productDetails.features;
          this.featuresList.forEach((featue: any, index: any) => {
            featue.theme1 = this.colorsList[index].theme1;
            featue.theme2 = this.colorsList[index].theme2;
          })
          this.phasesList = this.productDetails.phases;
          this.phasesList.forEach((featue: any, index: any) => {
            featue.theme1 = this.colorsList1[index].theme1;
            featue.theme2 = this.colorsList1[index].theme2;
          })
          this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.productDetails.url);
          if(this.dom.URL.includes('?coupon_code=')){
            this.getCoupons()
          }
          if(this.dom.URL.includes('utm_source') || this.dom.URL.includes('utm_medium') || this.dom.URL.includes('utm_campaign')){
            this.sessionStorage.setItem('utmLink', this.dom.URL.split('?')[1])
          }
         
        }
       
      }
    })

  }

  public dialogClose(ev: any) {
    this.displayShareButtons = false;
  }


  public shareCode() {
    this.displayShareButtons = !this.displayShareButtons;
  }

  couponList:any[]=[];
  personalisedCoupon:any;
  getCoupons() {
    this.couponList = []

    this.cartService.getProductCoupons(this.productId).subscribe(res => {
      if (res.success) {
        //  && item.show_coupon
        res.data.forEach((item: any) => {
          if (item.status) {
            this.couponList.push(item)
          }
        })
        if(this.couponCode){
          let couponObj:any = this.couponList.filter((x:any)=> x.coupon_name.toLowerCase() == this.couponCode.toLowerCase())[0]
          if(couponObj){
            this.discountAmount = couponObj.discount_amount;
            this.sessionStorage.setItem('couponCode', this.couponCode);
            this.getTotalPrice()
          }
        }
       let couponlist:any []= this.couponList.filter((x:any)=> !x.show_coupon && x.status )
       this.personalisedCoupon = couponlist.sort((x:any, y:any)=> parseInt(x.discount_amount) > parseInt(y.discount_amount) ? -1:1 )[0]
        // this.couponList = res.data
      }
    })

  }

  ngOnDestroy() {
    // clearInterval(this.intervalForDays)
    this.sessionStorage.removeItem('enrollNow')

  }

  getVideoUrl(obj: any) {
    const dialogref = this.dialog.open(VideoPlayerDialog, {
      width: '800px',
      data: { video: obj.url ? obj.url : obj.img_url, type: 'toppers', viewtype: obj.url ? 'video' : 'image' },
      panelClass: ['video-dialog', 'video-dilogue2']
    })
    dialogref.afterClosed().subscribe(result => {

    })
    // return this.sanitizer.bypassSecurityTrustResourceUrl(obj.url);
  }

  downloadFile(){
    const dialog = this.dialog.open(DownloadForm, {
      width: '450px',
      panelClass: 'enquiry-modal',
      data: this.productDetails
    })
    dialog.afterClosed().subscribe(res=>{
      if(res){
        window.open(this.productDetails.pdf_file_url, '_blank')
      }
    })
  }

  getFaqs() {
    this.coursesService.getFaqs(this.productId).subscribe(res => {
      if (res.success) {
        this.faqsList = res.data;
      }
    })
  }

  hidetext: boolean = false;
  hidetext1: boolean = false;


  showAll: boolean = false;

  showContent() {
    this.hidetext = !this.hidetext;
    if (this.descCount == this.productDetails.description.length - 1) {
      this.descCount = 426;
    } else {
      this.descCount = this.productDetails.description.length - 1;
    }
  }

  showContent1() {
    this.hidetext1 = !this.hidetext1;
    if (this.descCount1 == this.productDetails.benefits.length - 1) {
      this.descCount1 = 426;
    } else {
      this.descCount1 = this.productDetails.benefits.length - 1;
    }
  }

  buynow1() {
    this.showAll = true;
    const dialog = this.dialog.open(FooterViewDialog1, {
      width: '700px',
      panelClass: ['footer-view', 'new-footer'],
      data: this.productDetails
    })

    dialog.afterClosed().subscribe(res => {
      if (res) {
        if (this.sessionStorage.getItem('usertoken')) {
          this.token = this.sessionStorage.getItem('usertoken');
          this.getProfile()
        }
        this.addonList = res.course_list;
        this.couponCode = res.coupon_code;
        this.discountAmount = res.discountAmount;
        this.buynow(res)
      } else {
        this.ngOnInit()
      }
    })

  }


  slickInit1(e: any) {
  }

  breakpoint1(e: any) {
  }

  afterChange1(e: any) {
  }

  beforeChange1(e: any) {
  }

  slickInit(e: any) {
  }

  breakpoint(e: any) {
  }

  afterChange(e: any) {
  }

  beforeChange(e: any) {
  }

  activePhase:any;
  selectedPhaseIndex:any = 0;

  changePhase(phaseObj:any, index:any){
    this.activePhase = phaseObj;
    this.selectedPhaseIndex = index;
  }

  index = 0;
  next_slide() {
    let index = this.index;

    const prev: any = document.querySelector(".prev");
    const next: any = document.querySelector(".next");
    const carousel: any = document.querySelector(".carousel-container");
    const track: any = document.querySelector(".track");
    let width = carousel.offsetWidth;

    if (index < 1) {
      index = index + 1;
      prev.classList.add("show");
      track.style.transform = "translateX(" + index * -width + "px)";
    }


    if (index == 1) {
      next.classList.add("hide");
      prev.classList.remove("hide");
    }
    this.index = index;
  }

  previous_slide() {
    let index = this.index;
    const prev: any = document.querySelector(".prev");
    const next: any = document.querySelector(".next");
    const carousel: any = document.querySelector(".carousel-container");
    const track: any = document.querySelector(".track");
    let width = carousel.offsetWidth;
    if (index > 0) {
      index = index - 1;
      next.classList.remove("hide");
      track.style.transform = "translateX(" + index * -width + "px)";

    }

    if (index === 0) {
      prev.classList.add("hide");
    }
    this.index = index
  }

  download() {
    if (this.productDetails.brochure_pdf_url) {
      window.open(this.productDetails.brochure_pdf_url, '_blank')
    }
  }
  usersEnrolled: any;
  getFakeNumber() {
    this.coursesService.getUsersEnrolled(this.productId).subscribe(res => {
      if (res.success) {
        this.usersEnrolled = res.fake_number_count;
      }
    })
  }

 
 
  starMentors() {
    const dialogref = this.dialog.open(StarMentorsDialog, {
      width: '1000px',
      panelClass: 'books-dilogue'
    })
    dialogref.afterClosed().subscribe(result => {

    })
  }

  aboveTemplate = `<div class="books-modal-wrapper">

  <div class="row">
      <div class="col-md-12">
          <div class="header-modal">
              <h2>CAT Books</h2>
              <button (click)="close()" data-modal-element-close-button="" class="modal-close-button" data-modal-close="" aria-label="Close Getting started section">
                  <span data-modal-element-close-icon="" class="modal-close-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.12,10l4.07-4.06a1.5,1.5,0,1,0-2.11-2.12L10,7.88,5.94,3.81A1.5,1.5,0,1,0,3.82,5.93L7.88,10,3.81,14.06a1.5,1.5,0,0,0,0,2.12,1.51,1.51,0,0,0,2.13,0L10,12.12l4.06,4.07a1.45,1.45,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"></path></svg></span>
              </button>
          </div>
      </div>
  </div>
  
  <div class="row">
      
      <div class="col-md-3 px-0">
          <div class="img">
              <img src="https://media.iquanta.in/ui_images/Hard+Copy/QA+BOOK+4.webp" alt="">
          </div>
      </div>

      <div class="col-md-3 px-0">
          <div class="img">
              <img src="https://media.iquanta.in/ui_images/Hard+Copy/QA+BOOK+1.webp" alt="">
          </div>
      </div>

      <div class="col-md-3 px-0">
          <div class="img">
              <img src="https://media.iquanta.in/ui_images/Hard+Copy/QA+BOOK+2.webp" alt="">
          </div>
      </div>

      <div class="col-md-3 px-0">
          <div class="img">
              <img src="https://media.iquanta.in/ui_images/Hard+Copy/QA+BOOK+3.webp" alt="">
          </div>
      </div>

      <div class="col-md-3 px-0">
          <div class="img">
              <img src="https://media.iquanta.in/ui_images/Hard+Copy/QA+BOOK+5.webp" alt="">
          </div>
      </div>

      <div class="col-md-3 px-0">
          <div class="img">
              <img src="https://media.iquanta.in/ui_images/Hard+Copy/LR+1.png" alt="">
          </div>
      </div>

      <div class="col-md-3 px-0">
          <div class="img">
              <img src="https://media.iquanta.in/ui_images/Hard+Copy/LR+2.png" alt="">
          </div>
      </div>

      <div class="col-md-3 px-0">
          <div class="img">
              <img src="https://media.iquanta.in/ui_images/Hard+Copy/RC+1.png" alt="">
          </div>
      </div>
  </div>
  </div>`;
  successStories: any[] = [{
    img: 'https://media.iquanta.in/ui_images/gursimranprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/aayishrofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/karalprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/avinashprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/shubashishprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/biswaruoprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/gautamprofile.jpeg'
  }]
  toppers2023: any[] = [
    
    
    {
      img:'https://media.iquanta.in/ui_images/topper-1.jpeg'
    },
    {
    
    img:'https://media.iquanta.in/ui_images/topper-2.jpeg'
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-3.jpeg'
    },
    {
    
    img:'https://media.iquanta.in/ui_images/topper-4.jpeg'

    },
    {
      img: 'https://media.iquanta.in/ui_images/topper-5.jpeg'
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-6.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-7.jpeg'
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-8.jpeg'
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-9.jpeg'
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-10.jpeg'
    },
    {
      img: 'https://media.iquanta.in/ui_images/topper-11.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-12.jpeg'
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-13.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-14.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-15.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-16.jpeg',
    },
    {
      img: 'https://media.iquanta.in/ui_images/topper-17.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-18.jpeg',
    },
    {
      img: 'https://media.iquanta.in/ui_images/topper-19.jpeg',
    },
    
  
    {
      img:'https://media.iquanta.in/ui_images/topper-20.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-21.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-22.jpeg',
    },
    {
      img:'https://media.iquanta.in/ui_images/topper-23.jpeg',
    },
    {
      img: 'https://media.iquanta.in/ui_images/topper-24.jpeg',
    },
    {
      img: 'https://media.iquanta.in/ui_images/topper-25.jpeg',
    },
  
  

  ]
  slider1: any[] = [
    { img: 'https://media.iquanta.in/ui_images/Rishi-Mittal.webp', video: 'd8Datuvi4L4', percent: 'CAT 100%iler' },
    { img: 'https://media.iquanta.in/ui_images/mayank.webp', video: 'v8O8ELvatPc', percent: 'CAT 99.76%iler' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper2.jpg', video: '0udGFVgMd84', percent: 'CAT 99.5%iler' },
    { img: 'https://media.iquanta.in/ui_images/Rahul-Agrawal.webp', video: 'GIrpNkOa8kQ', percent: 'CAT 99.92%iler' },
    { img: 'https://media.iquanta.in/ui_images/Karal-Maheshwari.webp', video: 'FjQPFPxlEjc', percent: 'CAT 99%iler' },
    { img: 'https://media.iquanta.in/ui_images/Kislay-Jha.webp', video: 'uUUseqANr7w', percent: 'CAT 99.96%iler' },
    { img: 'https://media.iquanta.in/ui_images/Karan-Dutta.webp', video: 'U7v8MmhfaOQ', percent: 'CAT 99.56%iler' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper1.jpg', video: 'zHxUBf-yOhk', percent: 'CAT 99.97%iler' }
  ]

  slider2: any[] = [
    { img: 'https://media.iquanta.in/ui_images/new-home/Charchil-Jain.jpg', video: 'DX4Vc4OFP0A', percent: 'CAT 99.38%iler' },
    { img: 'https://media.iquanta.in/ui_images/new-home/Piyush-Aras.jpg', video: 'MnMo2bI8gS8', percent: 'CAT 99.2%iler' },
    { img: 'https://media.iquanta.in/ui_images/new-home/Palak-Aneja.jpg', video: '3hKoGXGpg3s', percent: 'CAT 99%iler' },
    { img: 'https://media.iquanta.in/ui_images/new-home/abhinav.jpg', video: 'Ug8lHINfDuM', percent: 'CAT 99.11%iler' },
    { img: 'https://media.iquanta.in/ui_images/new-home/Farzan-Shaikh.jpg', video: '8zEpUEvLB_E', percent: 'CAT 99.94%iler' },
    { img: 'https://media.iquanta.in/ui_images/new-home/rushikesh.jpg', video: 'AvDNi1DvEOs', percent: 'IIM Bangalore' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper4.jpg', video: 'apsnogTzGjg', percent: 'IIM Convert' }
  ]
  public onHoverCard(cardVal:any){
    this.hoverCardVal = cardVal;
  }
  public hoverCardVal:any = 'topper1';

  gallery(index:any) {
    const dialogref = this.dialog.open(GalleryDialog, {
      width: 'auto',
      panelClass: 'gallery-dilogue',
      data: { index: index, images: this.successStories}
    })
    dialogref.afterClosed().subscribe(result => {

    })
  }

  
  emioption(){
    let whatsappTemplate:any = `Hi Team iQuanta! 

I’m keen to enrol in the ${this.productDetails.name} and would like to know more about your EMI/payment-plan options. Could you please share the details? 

Thanks!`
    window.open('https://api.whatsapp.com/send/?phone=918130900243&text='+encodeURI(whatsappTemplate), '_blank')
  }

  
  ngAfterView(){

    if(this.dom.URL.includes('?referral_code=')){
      this.referralCode = this.dom.URL.split('?referral_code=')[1];
      if(!this.sessionStorage.getItem('usertoken')){
        this.matSnackBar.open('Please login to apply referral code, Login window will not close until you login.', 'OK',{
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
        const dialogRef = this.dialog.open(LoginModal, {
          width: '750px',
          panelClass: 'login_modal',
          autoFocus: false,
          disableClose:true
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result == 'yes') {

          } else if (typeof (result) == 'object') {
            if (this.sessionStorage.getItem('usertoken')) {
              this.token = this.sessionStorage.getItem('usertoken');
              this.getProfile()
            } else {
              this.userData = result;
              this.token = this.sessionStorage.getItem('usertoken');;
              this.sessionStorage.setItem('userData', JSON.stringify(result));
              this.loginService.userProfile(this.userData)
              if(this.dom.URL.includes('?referral_code=')){
                this.applyReferralCode()
              }
            }
          }
        });
      }else{
        this.applyReferralCode()
      }
    }
  }

  applyReferralCode(){
    let reqData = {
      code: this.referralCode,
      id: this.productId
    }
    this.cartService.applyProductReferralCode(this.token, reqData).subscribe(res => {
      if (res.success && res.data != 'referral_code does not exist') {
        this.referralAmount = res.data[0].amount;
        this.getTotalPrice()
      } else {
        this.matSnackBar.open(res.data, 'OK', {
          verticalPosition: 'top',
          duration: 2000,
          panelClass: 'snack-error'
        })
        this.sessionStorage.removeItem('referralCode')
      }
    })
  }



  iniSlickJs() {
    const htmlScriptElement = document.createElement('script');
    htmlScriptElement.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js';
    this.elementRef.nativeElement.appendChild(htmlScriptElement);
    const htmlScriptElement1 = document.createElement('script');
    htmlScriptElement1.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js';
    this.elementRef.nativeElement.appendChild(htmlScriptElement1);
  }

  slideConfig3 = {
    "slidesToShow": 4, "slidesToScroll": 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]



  };
  
  playVideo2(obj: any) {
   
  }



  addOnCoupon(): void {
    const dialogRef = this.dialog.open(addOnCouponDialog, {
      panelClass: 'add_on_modal',
      data: { id: this.productId, details: this.productDetails, coupon: this.couponCode, referralamount: this.referralAmount,
        discount: this.discountAmount, referralcode: this.referralCode, addonList: this.addonList
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(res => {
      this.sessionStorage.removeItem('enrollNow')
      if(res.success){
        this.sessionStorage.setItem('order_id', res.order_id)
        this.productDetails.addOns = res.courseList;
        if (this.discountAmount > 0) {
          this.productDetails.discount_amount = this.discountAmount;
        } else if (this.referralAmount > 0) {
          this.productDetails.referral_amount = this.referralAmount;
        }
        this.sessionStorage.setItem('productArray', JSON.stringify(this.productDetails))
        if (res.redirect_url) {
          let url = res.redirect_url.split('?')

          this.sessionStorage.setItem('queryParams', JSON.stringify(url[url.length - 1]))
          this.router.navigate(['/success'])
        } else {
          // alert(JSON.stringify(res))
          window.open(res.data, '_self')
        }
      }else{
        this.addonList = res;
        this.getTotalPrice()
      }
    });
  }

}


@Component({
  selector: 'add-on-dilogue',
  templateUrl: './add-on-dilogue.html',
  styleUrls: ['./new-product.component.scss']
})


export class addOnCouponDialog {
  personalisedCoupon:any;

  productDetails:any;
  showTooltipFlag:boolean = false;
  toolTipObj: any;
  addonList:any[]=[];
  discountAmount:any = 0;
  referralAmount:any = 0;
  token:any;
  productId:any;
  couponCode:any;
  timerconfig:any;
  public displayShareButtons: boolean = false;
  constructor(public dialogRef: MatDialogRef<addOnCouponDialog>, public coursesService: CoursesService,
    public matSnackBar: MatSnackBar, public dashboardService: DashboardService,  @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public loginService: LoginService, public cartService: CartService, public router: Router, public dialog: MatDialog,
    @Inject(DOCUMENT) public dom:any, @Inject(MAT_DIALOG_DATA) public data:any,) {
    this.productId = this.data.id;
    this.productDetails = this.data.details;
    this.couponCode = this.data.coupon;
    this.referralAmount = this.data.referralamount;
    this.discountAmount = this.data.discount;
    this.addonList = this.data.addonList
    this.referralCode = this.data.referralcode;
    this.getCoupons()
    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
      this.getProfile()
      this.getWishList()
    }
    this.getTotalPrice()
    this.timerconfig = {
      leftTime: 900,
      notify: [5]
    }
  }

  couponList:any[] = [];

  getCoupons() {
    this.couponList = []

    this.cartService.getProductCoupons(this.productId).subscribe(res => {
      if (res.success) {
        //  && item.show_coupon
        res.data.forEach((item: any) => {
          if (item.status) {
            this.couponList.push(item)
          }
        })
        if(this.couponCode){
          let couponObj:any = this.couponList.filter((x:any)=> x.coupon_name.toLowerCase() == this.couponCode.toLowerCase())[0]
          if(couponObj){
            this.discountAmount = couponObj.discount_amount;
            this.sessionStorage.setItem('couponCode', this.couponCode);
            this.getTotalPrice()
          }
        }
       let couponlist:any []= this.couponList.filter((x:any)=> !x.show_coupon && x.status )
       this.personalisedCoupon = couponlist.sort((x:any, y:any)=> parseInt(x.discount_amount) > parseInt(y.discount_amount) ? -1:1 )[0]
        // this.couponList = res.data
      }
    })

  }

  applycoupon(){
    this.discountAmount = this.personalisedCoupon.discount_amount;
    this.couponCode = this.personalisedCoupon.coupon_code;
    this.timerconfig = {
      leftTime: 900,
      notify: [5]
    }
    this.getTotalPrice()
  }

  joinwhatsappEnquiry(link:any){
    let whatsappTemplate:any = `Hi iQuanta! 
    
    I’m interested in the ${this.productDetails.name} and have a few questions about the syllabus, fees, batch dates and remaining seats. Could you please help me with the details? 
    
    Thanks!`
    window.open(link+'&text='+encodeURI(whatsappTemplate), '_blank')
    
    }

    emioption(){
      let whatsappTemplate:any = `Hi Team iQuanta! 

I’m keen to enrol in the ${this.productDetails.name} and would like to know more about your EMI/payment-plan options. Could you please share the details? 

Thanks!`
      window.open('https://api.whatsapp.com/send/?phone=918130900243&text='+encodeURI(whatsappTemplate), '_blank')
    }

  gotodashboard(){
    this.sessionStorage.setItem('selId', this.productDetails.linked_courses[0].id);
    this.dialogRef.close()
    this.router.navigate(['/dashboard/my-courses/overview'])
  }

  removefromcart(obj:any){
    let i = this.addonList.indexOf(obj)
    this.addonList.splice(i, 1)
    this.getTotalPrice()
  }

  timerEvent: any;

  handleEvent(ev: any) {
    if (ev.action == 'done') {
      this.timerEvent = ev;
     
    }
    //  else if (ev.action == 'notify') {
    //   this.timerEvent = ev;
    // }
  }

  onCloseClick(){
    this.dialogRef.close(this.addonList.length > 0 ? this.addonList : [])
  }

  download() {
    if (this.productDetails.brochure_pdf_url) {
      window.open(this.productDetails.brochure_pdf_url, '_blank')
    }
  }

  public dialogClose(ev: any) {
    this.displayShareButtons = false;
  }


  public shareCode() {
    this.displayShareButtons = !this.displayShareButtons;
  }

  removeCoupon() {
    this.discountAmount = 0;
    this.couponCode = '';
    this.sessionStorage.removeItem('couponCode')
    this.sessionStorage.removeItem('referralCode')
    this.referralAmount = 0;
    this.referralCode = '';
    this.getTotalPrice()
  }

  getProfile() {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.userData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.loginService.userProfile(this.userData)
        
      }
    })
  }
  userData: any;
  gmaillogin(reqObj: any, type: any) {
    let reqData = {
      id: reqObj.google_id,
      username: reqObj.name + '-' + reqObj.google_id,
      email: reqObj.email,
      gmail_pic: reqObj.google_pic
    }
    this.loginService.gmail_login(reqData).subscribe(res => {
      if (res.success) {
        this.userData = reqData;
        this.token = res.key;
        this.sessionStorage.setItem('usertoken', this.token);
        this.sessionStorage.setItem('userData', JSON.stringify(reqData));
        this.loginService.userProfile(this.userData)
        // this.onLogin.emit(this.token)
        if (type == 'checkout') {
          this.loginService.userProfile(this.userData)
        } else {
          this.couponOpen()
        }
      }
    })
  }

  talktous(){
    const dialog = this.dialog.open(CallActionDialog, {
      width: '350px',
      panelClass: 'call-dialog',
      autoFocus: false
    })
  }

  submittedBuynow: boolean = false;

  buynow(obj: any) {
    let hardcopyList: any[] = [];
    this.addonList.forEach(addon => {
      hardcopyList.push(addon.contains_hardcopy)
    })
    if (!this.submittedBuynow) {
      if (this.token) {
        if (this.userData.email && this.userData.phone_no && this.userData.first_name) {
          if (this.productDetails.contains_hardcopy || hardcopyList.includes(true)) {
            const dialog = this.dialog.open(FormDialog, {
              width: '450px',
              panelClass: 'enquiry-modal',
              data: this.userData
            })
            dialog.afterClosed().subscribe(res => {
              if (res) {
                this.submittedBuynow = true;
                let courseList: any[] = [];
                this.addonList.forEach(addon => {
                  courseList.push(addon.id)
                })
                let reqObj: any;
                if (this.couponCode) {
                  reqObj = {
                    email: obj ? obj.email : this.userData.email,
                    phone: obj ? obj.phone : this.userData.phone_no,
                    product_id: this.productId,
                    course_list: courseList,
                    coupon_code: this.couponCode,
                    subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
                  }
                } else if (this.referralCode) {
                  reqObj = {
                    email: obj ? obj.email : this.userData.email,
                    phone: obj ? obj.phone : this.userData.phone_no,
                    product_id: this.productId,
                    course_list: courseList,
                    referral_code: this.referralCode,
                    subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
                  }
                } else {
                  reqObj = {
                    email: obj ? obj.email : this.userData.email,
                    phone: obj ? obj.phone : this.userData.phone_no,
                    product_id: this.productId,
                    course_list: courseList,
                    subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
                  }
                }
                this.cartService.productCheckout(this.token, reqObj).subscribe(res => {
                  if (res.success) {
                    res.courseList = courseList;
                    this.dialogRef.close(res)
                  } else {
                    this.submittedBuynow = false;
                    this.matSnackBar.open(res.data, 'OK', {
                      verticalPosition: 'top',
                      duration: 3000,
                      panelClass: 'snack-error'
                    })
                  }
                })
              }
            })
          } else {
            this.submittedBuynow = true;
            let courseList: any[] = [];
            this.addonList.forEach(addon => {
              courseList.push(addon.id)
            })
            let reqObj: any;
            if (this.couponCode) {
              reqObj = {
                email: obj ? obj.email : this.userData.email,
                phone: obj ? obj.phone : this.userData.phone_no,
                product_id: this.productId,
                course_list: courseList,
                coupon_code: this.couponCode,
                subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
              }
            } else if (this.referralCode) {
              reqObj = {
                email: obj ? obj.email : this.userData.email,
                phone: obj ? obj.phone : this.userData.phone_no,
                product_id: this.productId,
                course_list: courseList,
                referral_code: this.referralCode,
                subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
              }
            } else {
              reqObj = {
                email: obj ? obj.email : this.userData.email,
                phone: obj ? obj.phone : this.userData.phone_no,
                product_id: this.productId,
                course_list: courseList,
                subcategory_course: this.productDetails.subcategory_course_id,
                    category_course: this.productDetails.category_course_id
              }
            }
            this.cartService.productCheckout(this.token, reqObj).subscribe(res => {
              if (res.success) {
                res.courseList = courseList;
               this.dialogRef.close(res)
              } else {
                this.submittedBuynow = false;
                this.matSnackBar.open(res.data, 'OK', {
                  verticalPosition: 'top',
                  duration: 3000,
                  panelClass: 'snack-error'
                })
              }
            })
          }

        } else {
          this.matSnackBar.open('Please update your Profile to continue', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        }

      } else {
        const dialogRef = this.dialog.open(LoginModal, {
          width: '750px',
          panelClass: 'login_modal',
          autoFocus: false
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result == 'yes') {

          } else if (typeof (result) == 'object') {
            if (this.sessionStorage.getItem('usertoken')) {
              this.token = this.sessionStorage.getItem('usertoken');
              this.getProfile()
            } else {
              this.userData = result;
              this.token = this.sessionStorage.getItem('usertoken');;
              this.sessionStorage.setItem('userData', JSON.stringify(result));
              this.loginService.userProfile(this.userData)
            }
          }
        });
      }
    }else{
      console.log('sdfsdfsdf')
    }
  }

  referralCode: any;
  //coupon Modal
  couponOpen() {
    if (this.token) {
      const dialog = this.dialog.open(ProductCouponDialog1, {
        width: '470px',
        panelClass: 'coupon-modal',
        data: this.productId
      })
      dialog.afterClosed().subscribe(res => {
        if (res) {
          if (res.data == 'Invalid Code or Not available for this course') {
            this.sessionStorage.removeItem('couponCode')
          } else if (res.data == 'referral_code does not exist') {
            this.sessionStorage.removeItem('referralCode')
          } else {
            if (res.data[0].amount) {
              this.referralAmount = res.data[0].amount;
              this.referralCode = this.sessionStorage.getItem('referralCode')
              this.getTotalPrice()

            } else {
              this.discountAmount = res.data[0].discount_amount;
              this.couponCode = this.sessionStorage.getItem('couponCode');
              this.getTotalPrice()
            }

          }
        }
      })
    } else {
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {

        } else if (typeof (result) == 'object') {
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()
          } else {
            this.gmaillogin(result, 'coupon')
          }
        }
      });
    }

  }

  gotolink() {
    if (this.toolTipObj.course_link) {
      window.open(this.toolTipObj.course_link)
    }
  }

  close(){
    this.dialogRef.close()
  }

  hideToolTip() {
    this.showTooltipFlag = false;
    this.toolTipObj = '';
  }

  addonCourse(obj: any) {
      this.addonList.push(obj)
    this.getTotalPrice()
  }


  totalAmount: number = 0;
  getTotalPrice() {
    let total = 0;
    if (this.addonList.length == 0) {
      total = this.productDetails.price - (this.discountAmount ? this.discountAmount : this.referralAmount);
    } else {
      let subtotal = 0;
      this.addonList.forEach(course => {
        subtotal = subtotal + course.special_price
      })
      total = (this.productDetails.price - (this.discountAmount ? this.discountAmount : this.referralAmount)) + subtotal;
    }

    this.totalAmount = total;
  }

  wishList: any[] = []
  addToWishlist() {
    if (this.token) {
      this.coursesService.addToWishList({ product_id: this.productId }, this.token).subscribe(res => {
        if (res.success) {
          this.matSnackBar.open('Added to Wishlist', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-success'
          })
          this.wishList.push(this.productId)
        }
      })
    } else {
      this.matSnackBar.open('Please Login to Wishlist', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }
  }

  getWishList() {
    this.wishList = [];
    this.dashboardService.getWishList(this.token).subscribe(res => {
      if (res.success) {
        res.data.forEach((item: any) => {
          item.product.forEach((item1: any) => {
            this.wishList.push(JSON.stringify(item1.id))
          })
        })
      }
    })
  }

  removeWishlist() {
    this.dashboardService.removeWishlist(this.token, this.productId).subscribe(res => {
      if (res.success) {
        this.matSnackBar.open('Removed from Wishlist', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-success'
        })
        this.getWishList()
      }
    })
  }

  showTooltip(addon: any) {
    this.showTooltipFlag = true;
    this.toolTipObj = addon;
  }

}



@Component({
  selector: 'product-coupon1-dialog',
  templateUrl: './coupon.html',
  styleUrls: ['./new-product.component.scss']
})
export class ProductCouponDialog1 {
  cartArray: any;
  couponCode: any;
  couponList: any[] = [];
  token: any;
  referralCode: any;
  constructor(public dialogRef: MatDialogRef<ProductCouponDialog1>, public cartService: CartService,
    @Inject(LOCAL_STORAGE) public sessionStorage: any, public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.token = this.sessionStorage.getItem('usertoken');
    this.getCoupons()
  }

  getCoupons() {
    this.couponList = []

    this.cartService.getProductCoupons(this.data).subscribe(res => {
      if (res.success) {
        //  && item.show_coupon
        res.data.forEach((item: any) => {
          if (item.status && !item.show_coupon) {
            this.couponList.push(item)
          }
        })
        // this.couponList = res.data
      }
    })

  }

  applyCoupon(obj: any) {
    this.couponCode = obj.coupon_code;
    this.apply()
  }

  couponMessage: any;
  couponApplied: boolean = false;
  apply() {
    if (this.couponCode) {
      let reqData = {
        code: this.couponCode,
        id: this.data
      }

      this.cartService.applyProductCoupon(this.token, reqData).subscribe(res => {
        if (res.success) {
          this.sessionStorage.setItem('couponCode', this.couponCode)
          this.dialogRef.close(res)
        } else {
          this.matSnackBar.open(res.data, 'OK', {
            verticalPosition: 'top',
            duration: 2000,
            panelClass: 'snack-error'
          })
          this.couponMessage = res.data
          this.couponApplied = false;
          this.cartArray.discount_amount = '';
          this.sessionStorage.removeItem('couponCode')
          this.sessionStorage.setItem('cartArray', JSON.stringify(this.cartArray))
        }
      })

    } else if (this.referralCode) {
      let reqData = {
        code: this.referralCode,
        id: this.data
      }
      this.cartService.applyProductReferralCode(this.token, reqData).subscribe(res => {
        if (res.success && res.data != 'referral_code does not exist') {
          this.sessionStorage.setItem('referralCode', this.referralCode)
          this.dialogRef.close(res)
        } else {
          this.matSnackBar.open(res.data, 'OK', {
            verticalPosition: 'top',
            duration: 2000,
            panelClass: 'snack-error'
          })
          this.couponMessage = res.data
          this.couponApplied = false;
          this.cartArray.referral_amount = '';
          this.sessionStorage.removeItem('referralCode')
          this.sessionStorage.setItem('cartArray', JSON.stringify(this.cartArray))
        }
      })
    } else {
      this.matSnackBar.open('Enter Coupon/Referral Code', 'OK', {
        verticalPosition: 'top',
        duration: 2000,
        panelClass: 'snack-error'
      })
    }


  }

}

@Component({
  selector: 'footer1-view',
  templateUrl: './footer-view.html',
  styleUrls: ['./new-product.component.scss']
})

export class FooterViewDialog1 {

  token: any;
  discountAmount: any = 0;
  couponCode: any;
  userData: any;
  productId: any;
  public displayShareButtons: boolean = false;
  @ViewChildren("myTooltip") myTooltip = new QueryList<MatTooltip>();
  referralCode: any;
  constructor(public dialogRef: MatDialogRef<FooterViewDialog1>, @Inject(MAT_DIALOG_DATA) public productDetails: any,
  @Inject(DOCUMENT) public dom: any,  @Inject(LOCAL_STORAGE) public sessionStorage: any, public cartService: CartService,
    public router: Router, public matSnackBar: MatSnackBar, public dialog: MatDialog, public dashboardService: DashboardService,
    public loginService: LoginService, public coursesService: CoursesService) {
    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.getProfile('')
      this.getWishList()

    }
    this.productId = this.productDetails.id;

    // this.addonCourse({ checked: true }, this.productDetails.addons[0])
    this.getTotalPrice()


  }

  joinwhatsappEnquiry(link:any){
    let whatsappTemplate:any = `Hi iQuanta! 
    
    I’m interested in the ${this.productDetails.name} and have a few questions about the syllabus, fees, batch dates and remaining seats. Could you please help me with the details? 
    
    Thanks!`
    window.open(link+'&text='+encodeURI(whatsappTemplate), '_blank')
    
    }

  emioption(){
    let whatsappTemplate:any = `Hi Team iQuanta! 

I’m keen to enrol in the ${this.productDetails.name} and would like to know more about your EMI/payment-plan options. Could you please share the details? 

Thanks!`
    window.open('https://api.whatsapp.com/send/?phone=918130900243&text='+encodeURI(whatsappTemplate), '_blank')
  }

  public shareCode() {
    this.displayShareButtons = !this.displayShareButtons;
  }
  public dialogClose(ev: any) {
    this.displayShareButtons = false;
  }
  toolTipObj: any;
  showTooltipFlag1: boolean = false;
  gotolink1() {
    if (this.toolTipObj.course_link) {
      this.showTooltipFlag1 = false;
      window.open(this.toolTipObj.course_link)
    }
  }

  displayTooltip(index: any) {
    this.showTooltipFlag1 = true;
    this.toolTipObj = this.productDetails.addons[index];
    // this.myTooltip.toArray()[index].disabled = false;
    // this.myTooltip.toArray()[index].show()
    // setTimeout(() => {
    //   this.myTooltip.toArray()[index].disabled = true;
    // }, 1000);
  }

  closeDialog() {
    this.sessionStorage.removeItem('enrollNow')
    this.dialogRef.close()
  }

  getProfile(val: any) {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.userData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.loginService.userProfile(this.userData)
        if (val == 'checkout') {
          this.buynow()
        }
      }
    })
  }
  gmaillogin(reqObj: any, type: any) {
    let reqData = {
      id: reqObj.google_id,
      username: reqObj.name + '-' + reqObj.google_id,
      email: reqObj.email,
      gmail_pic: reqObj.google_pic
    }
    this.loginService.gmail_login(reqData).subscribe(res => {
      if (res.success) {
        this.userData = reqData;
        this.token = res.key;
        this.sessionStorage.setItem('usertoken', this.token);
        this.sessionStorage.setItem('userData', JSON.stringify(reqData));
        this.loginService.userProfile(this.userData)
        // this.onLogin.emit(this.token)
        if (type == 'checkout') {
          this.loginService.userProfile(this.userData)
        } else {
          this.couponOpen()
        }
      }
    })
  }

  referralAmount: any = 0;

  //coupon Modal
  couponOpen() {
    if (this.token) {
      const dialog = this.dialog.open(ProductCouponDialog1, {
        width: '470px',
        panelClass: 'coupon-modal',
        data: this.productId
      })
      dialog.afterClosed().subscribe(res => {
        if (res) {
          if (res.data == 'Invalid Code or Not available for this course') {
            this.sessionStorage.removeItem('couponCode')
          } else if (res.data == 'referral_code does not exist') {
            this.sessionStorage.removeItem('referralCode')
          } else {
            if (res.data[0].amount) {
              this.referralAmount = res.data[0].amount;
              this.referralCode = this.sessionStorage.getItem('referralCode')
              this.getTotalPrice()

            } else {
              this.discountAmount = res.data[0].discount_amount;
              this.couponCode = this.sessionStorage.getItem('couponCode');
              this.getTotalPrice()
            }

          }

        }
      })
    } else {
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {

        } else if (typeof (result) == 'object') {
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile('coupon')
          } else {
            this.gmaillogin(result, 'coupon')
          }
        }
      });
    }

  }




  removeCoupon() {
    this.discountAmount = 0;
    this.couponCode = '';
    this.referralAmount = 0;
    this.referralCode = '';
    this.sessionStorage.removeItem('couponCode')
    this.sessionStorage.removeItem('referralCode')
    this.getTotalPrice()
  }

  checkLogin() {
    const dialogRef = this.dialog.open(LoginModal, {
      width: '750px',
      panelClass: 'login_modal',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {

      } else if (typeof (result) == 'object') {
        if (this.sessionStorage.getItem('usertoken')) {
          this.token = this.sessionStorage.getItem('usertoken');
          this.getProfile('checkout')

        } else {
          this.userData = result;
          this.token = this.sessionStorage.getItem('usertoken');;
          this.sessionStorage.setItem('userData', JSON.stringify(result));
          this.loginService.userProfile(this.userData)
          setTimeout(() => {
            this.buynow()
          }, 1500)
        }
      }
    });
  }

  buynow() {
    if (this.token) {
      let courseList: any[] = [];
      this.addonList.forEach(addon => {
        courseList.push(addon.id)
      })
      let reqObj = {
        email: this.userData.email,
        phone: this.userData.phone_no,
        product_id: this.productId,
        course_list: this.addonList,
        coupon_code: this.couponCode,
        referral_code: this.referralCode,
        discountAmount: this.discountAmount,
        referralAmount: this.referralAmount
      }
      this.dialogRef.close(reqObj)
    } else {
      this.checkLogin()
    }


  }

  
  totalAmount: number = 0;
  getTotalPrice() {
    let total = 0;
    if (this.addonList.length == 0) {
      total = this.productDetails.price - (this.discountAmount ? this.discountAmount : this.referralAmount);
    } else {
      let subtotal = 0;
      this.addonList.forEach(course => {
        subtotal = subtotal + course.special_price
      })
      total = (this.productDetails.price - (this.discountAmount ? this.discountAmount : this.referralAmount)) + subtotal;
    }

    this.totalAmount = total;
  }
  wishList: any[] = []
  addToWishlist() {
    if (this.token) {
      this.coursesService.addToWishList({ product_id: this.productId }, this.token).subscribe(res => {
        if (res.success) {
          this.matSnackBar.open('Added to Wishlist', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-success'
          })

          this.wishList.push(this.productId)
        }
      })
    } else {
      this.matSnackBar.open('Please Login to Wishlist', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }
  }

  getWishList() {
    this.wishList = [];
    this.dashboardService.getWishList(this.token).subscribe(res => {
      if (res.success) {
        res.data.forEach((item: any) => {
          item.product.forEach((item1: any) => {
            this.wishList.push(item1.id)
          })
        })
      }
    })
  }

  download() {
    if (this.productDetails.brochure_pdf_url) {
      window.open(this.productDetails.brochure_pdf_url, '_blank')
    }
  }

  removeWishlist() {
    this.dashboardService.removeWishlist(this.token, this.productId).subscribe(res => {
      if (res.success) {
        this.matSnackBar.open('Removed from Wishlist', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-success'
        })
        this.getWishList()
      }
    })
  }

  addonList: any[] = []
  addonCourse(ev: any, obj: any) {
    if (!ev.checked) {
      let i = this.addonList.indexOf(obj)
      this.addonList.splice(i, 1)
    } else {
      this.addonList.push(obj)
    }
    this.getTotalPrice()
  }

}

@Component({
  selector: 'app-delivery-address',
  templateUrl: './delivery-address.html',
  styleUrls: ['./new-product.component.scss']
})

export class FormDialog {
  devlieryDateForm!: FormGroup;
  submittedBtn: boolean = false;
  url: any;
  page_loaction: any
  token: any;
  userData:any;

  constructor(public dialogRef: MatDialogRef<FormDialog>, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public matSnackBar: MatSnackBar, public courseService: CoursesService, public dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any, public loginService: LoginService,
  public dialog: MatDialog) {
    this.token = this.sessionStorage.getItem('usertoken');

    this.devlieryDateForm = this.formBuilder.group({
      city: [this.data.city, Validators.required],
      state: [this.data.state, Validators.required],
      address1: [this.data.address1, Validators.required],
      address2: [this.data.address2, Validators.required],
      pincode: [this.data.pincode, Validators.required],
      alternate_phone_number: [this.data.alternate_phone_number, Validators.required]
    })
    this.getCities()
  }

  cityList: any[] = [];
  getCities() {
    this.loginService.getCities().subscribe(res => {
      if (res.success) {
        this.cityList = res.data;
      }
    })
  }

  filter(event: any) {
    if (this.devlieryDateForm.value.city) {
      const filterValue = this.devlieryDateForm.value.city.toLowerCase();
      this.cityList = this.cityList.filter(option => option.city_name.toLowerCase().includes(filterValue));
    } else {
      this.getCities()
    }

  }

  save() {
    if (this.devlieryDateForm.valid) {
      if (this.token) {
        this.submittedBtn = true;
        this.courseService.addDeliveryAddress(this.token, this.devlieryDateForm.value).subscribe((res: any) => {
          if (res.message == 'User delivery address updated successfully') {
            this.dialogRef.close(res)
          } else if (!res.success) {

          }
        }, err => {
          this.dialogRef.close(err.error)
        })
      } else {
        this.login()
        // this.matSnackBar.open('Please Login', 'OK', {
        //   verticalPosition: 'top',
        //   duration: 3000,
        //   panelClass: 'snack-error'
        // })
      }
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }

  }

  getProfile() {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.userData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.loginService.userProfile(this.userData)
      }
    })
  }

  login(){
    const dialogRef = this.dialog.open(LoginModal, {
      width: '750px',
      panelClass: 'login_modal',
      autoFocus: false,
      data: 'Sign up - Delivery Address'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {

      } else if (typeof (result) == 'object') {
        if (this.sessionStorage.getItem('usertoken')) {
          this.token = this.sessionStorage.getItem('usertoken');
          this.getProfile()
        } else {
          this.userData = result;
          this.token = this.sessionStorage.getItem('usertoken');;
          this.sessionStorage.setItem('userData', JSON.stringify(result));
          this.loginService.userProfile(this.userData)
         
        }
      }
    });
  }

  addNPF() {
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.devlieryDateForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.devlieryDateForm.value.phone,
      "email": this.devlieryDateForm.value.email,
      "field_gender": '',
      "field_exam_category": this.devlieryDateForm.value.course,
      "field_exam": "",
      "field_course_year": '',
      "source": "Website",
      "medium": this.data ? this.data : 'Call Back Form'

    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {

    })

  }

  close() {
    this.dialogRef.close()
  }

}

@Component({
  selector: 'app-download',
  templateUrl: './download.html',
  styleUrls: ['./new-product.component.scss']
})

export class DownloadForm {

  devlieryDateForm!: FormGroup;
  submittedBtn: boolean = false;
  url: any;
  page_loaction: any
  token: any

  userData:any;

  constructor(public dialogRef: MatDialogRef<DownloadForm>, @Inject(MAT_DIALOG_DATA) public data: any,
    public formBuilder: FormBuilder, public loginService: LoginService, public matSnackbar: MatSnackBar,
  public dashboardService: DashboardService, @Inject(LOCAL_STORAGE) public sessionStorage: any, public deviceService: DeviceDetectorService,
@Inject(DOCUMENT) public dom:any) {
    this.devlieryDateForm = this.formBuilder.group({
      name: ['', Validators.required],
      phone_no: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      mail_id: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
    })
    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
    }
  }


  addInternalCRMLead() {
    // if (this.token) {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "orgId": "66dec57ce200bc89284602d6",
      "uid": '66dec57ce200bc89284602d6',
      "userId": this.userData ? this.userData.id : 9999,
      "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
      "name": this.devlieryDateForm.value.name,
      "firstName": this.devlieryDateForm.value.name,
      "countryCode": 91,
      "phone": this.devlieryDateForm.value.phone_no,
      "email": this.devlieryDateForm.value.mail_id,
      "source": "Website",
      "medium": "Download Syllabus & Strategy",
      "campaign": this.data.name,
      "pageLocation": this.dom.URL,
      "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
      "registrationDevice": this.deviceService.deviceType,
      "ipAddress": this.sessionStorage.getItem('ipAddress'),
      "customFields": {
        "exam": 'CAT',
        "examCategory": 'MBA',
        "examTargetYear": 2025,
      "leadPriority": "Platinum",

      },
      dataSource: [
        {
          utmSource: source,
          utmMedium: medium,
          utmCampaign: campaign,
          utmAdContent: "",
          "pageLocation": this.dom.URL,
          "source": "Website",
      "medium": "Download Syllabus & Strategy",
      "campaign": this.data.name,
          adContent: "",
  "ipAddress": this.sessionStorage.getItem('ipAddress'),
          browser: this.deviceService.browser,
          browser_version: this.deviceService.browser_version,
          device: this.deviceService.device,
          deviceType: this.deviceService.deviceType,
          orientation: this.deviceService.orientation,
          os: this.deviceService.os,
          os_version: this.deviceService.os_version,
          platformId: this.deviceService['platformId'],
          ua: this.deviceService.ua,
          userAgent: this.deviceService.userAgent
        },
      ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {

        }
      })
    // }
  }


  save() {
    if (this.devlieryDateForm.valid) {
      let reqObj = {
        name: this.devlieryDateForm.value.name,
        phone_no: this.devlieryDateForm.value.phone_no,
        mail_id: this.devlieryDateForm.value.mail_id,
        product_id: this.data.id,
      }
      this.loginService.userDetailsToDownload(reqObj).subscribe(res=>{
        if(res.success){
          this.addInternalCRMLead()
          this.dialogRef.close(res)
        }else{
          this.matSnackbar.open(res.data, 'OK',{
            verticalPosition: 'top',
            panelClass:'snack-error',
            duration: 3000
          })
        }
      }, err=>{
        this.matSnackbar.open(err.error.data, 'OK',{
          verticalPosition: 'top',
          panelClass:'snack-error',
          duration: 3000
        })
      })
    }else{
      this.matSnackbar.open('Please enter valid details', 'OK',{
        verticalPosition: 'top',
        panelClass:'snack-error',
        duration: 3000
      })
    }
  }

  close(){
    this.dialogRef.close()
  }

}